/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { onValidateLoginTokenReset } from '../../Store/Slices/validateLoginTokenSlice'
import Loader from '../../Components/Loader/Loader'
import { onGenerateTokenSubmitFullReset } from '../../Store/Slices/generateTokenSlice'

const Logout = () => {
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const V3Data = useSelector((state) => state.cardDataSliceReducer);
    // const V3DataUrl = new URL(V3Data?.SignInUrl).origin;



    let V3DataUrl = "";
    if (V3Data?.SignInUrl) {
        try {
            V3DataUrl = new URL(V3Data.SignInUrl, window.location.origin).origin;
        } catch (e) {
            console.error("Invalid URL:", V3Data.SignInUrl, e);
        }
    }

    useEffect(() => {

        if (sessionStorage.getItem("login")) {
            sessionStorage.removeItem("login");
            sessionStorage.removeItem("activityExpiryTime");
            localStorage.setItem("contactUs_reloaded", 'false');
            localStorage.setItem("logout", Date.now().toString());
            dispatch(onGenerateTokenSubmitFullReset());
            window.location.href = `${V3DataUrl}/Logout/${V3Data?.integrationId}/${sessionStorage.getItem("loginSessionToken")}`;
            dispatch(onValidateLoginTokenReset())
        } else {
            navigate("/")
        }
    }, [])

    return (
        <>
            <Loader />
        </>
    )
}

export default Logout